import { UserCreatePage } from "@/features/access/pages/user/UserCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/access/user/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_users.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: UserCreatePage,
});
